module.exports = __webpack_public_path__ + "img/1.0eb10a6a.png";